import React from "react";
import { NetworkQualityLevel } from "hooks/useNetworkQuality";
import "./style.scss";

interface Props {
  quality: NetworkQualityLevel;
  className?: string;
}

const LABELS: Record<NetworkQualityLevel, string> = {
  1: "Very poor",
  2: "Poor",
  3: "Fair",
  4: "Good",
  5: "Excellent",
};

export default function NetworkQualityBadge({ quality, className }: Props) {
  const bars = [1, 2, 3, 4, 5] as const;
  const cls = ["network-quality-badge"];
  if (className) cls.push(className);

  return (
    <div className={cls.join(" ")} title={LABELS[quality]} data-quality={quality} role="meter" aria-label={`Network quality: ${LABELS[quality]}`} aria-valuemin={1} aria-valuemax={5} aria-valuenow={quality}>
      {bars.map((level) => (
        <div
          key={level}
          className={`network-quality-badge__bar${level <= quality ? " __active" : ""}`}
          style={{ height: `${level * 3 + 2}px` }}
        />
      ))}
    </div>
  );
}
